import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { FormStore } from 'src/features/well-form/entities/form.entity';
import { SwitchButtonGroup } from 'src/shared/components/switch-button-group';
import { useStore } from 'src/store';

type Props = {
  formStore: FormStore;
};

export const WellFormTabs = observer(function WellFormTabs({ formStore }: Props) {
  const { directories } = useStore();
  const { t } = useTranslation();
  const unrecTab = t('newWellForm:Errors.unrecognizedTab');

  const items = [
    {
      key: formStore.mainDataTab.formElementRefId,
      title: directories.getFieldLabel(formStore.mainDataTab.formElementRefId) || unrecTab,
      count: formStore.mainDataTab.errorsCount,
      disabled: formStore.mainDataTab.isDisabled,
      tooltipText: formStore.mainDataTab.tooltipText,
      isTooltipVisible: formStore.mainDataTab.isDisabled ? undefined : false,
    },
    {
      // TODO: добавить условие заблокированности и количество ошибок на вкладке
      key: 'rigOperations',
      // title: directories.getFieldLabel(formStore.approachesTab.formElementRefId) || unrecTab,
      title: t('rigOperations:title'),
      // count: formStore.approachesTab.errorsCount,
      // disabled: formStore.approachesTab.isDisabled,
      // tooltipText: formStore.approachesTab.tooltipText,
      // isTooltipVisible: formStore.approachesTab.isDisabled ? undefined : false,
    },
    {
      // TODO: добавить условие заблокированности и количество ошибок на вкладке
      key: 'geologicalLoad',
      title: t('geologicalLoad:title'),
    },
  ];

  if (!items.length) {
    return null;
  }

  return (
    <SwitchButtonGroup
      items={items}
      defaultOptionKey={items[0].key}
      value={formStore.activeTabId}
      onChange={formStore.setActiveTab}
    />
  );
});
